import { ROLES } from '@/constants/roles';

export default [
  {
    path: '/customers',
    name: 'customers_list',
    component: () => import('@/views/pages/customers/CustomersList.vue'),
    meta: {
      pageTitle: 'Customers List',
      breadcrumb: {
        label: 'Customers List'
      },
      roles: [ROLES.ADMIN, ROLES.ACCOUNT_ADMIN],
      verticalMenu: {
        title: 'Customers List',
        icon: 'UserIcon'
      }
    }
  },
  {
    path: '/customers/create',
    name: 'create_customer',
    component: () => import('@/views/pages/customers/CreateCustomer.vue'),
    meta: {
      pageTitle: 'Create Customer',
      breadcrumb: {
        label: 'Customer List',
        parent: 'customers_list'
      },
      roles: [ROLES.ADMIN, ROLES.ACCOUNT_ADMIN]
    }
  },
  {
    path: '/customers/:id',
    name: 'customers_detail',
    component: () => import('@/views/pages/customers/EditCustomer.vue'),
    meta: {
      pageTitle: 'Edit Customers Infos',
      breadcrumb: {
        label: 'Edit Customers Infos',
        parent: 'customers_list'
      },
      roles: [ROLES.ADMIN, ROLES.ACCOUNT_ADMIN]
    }
  },
  {
    path: '/customers/:id/users',
    name: 'customers_user_list',
    component: () => import('@/views/pages/customers/CustomerUserList.vue'),
    meta: {
      pageTitle: 'Customer Users List',
      breadcrumb: {
        label: 'Customer Users List',
        parent: 'customers_list'
      },
      roles: [ROLES.ADMIN, ROLES.ACCOUNT_ADMIN]
    }
  },

  {
    path: '/customers/:id/users/create',
    name: 'create_customer_user',
    component: () => import('@/views/pages/customers/CreateCustomerUser.vue'),
    meta: {
      pageTitle: 'Create Customer User',
      breadcrumb: {
        label: 'Create Customer User',
        parent: 'customers_user_list'
      },
      roles: [ROLES.ADMIN, ROLES.ACCOUNT_ADMIN]
    }
  },

  {
    path: '/customers/:id/users/:user_id',
    name: 'customers_user_detail',
    component: () => import('@/views/pages/customers/EditCustomerUser.vue'),
    meta: {
      pageTitle: 'Customer User Infos',
      breadcrumb: {
        label: 'Customer User Infos',
        parent: 'customers_user_list'
      },
      roles: [ROLES.ADMIN, ROLES.ACCOUNT_ADMIN]
    }
  },

  {
    path: '/customers/:id/parameters',
    name: 'customers_parameters_list',
    component: () => import('@/views/pages/customers/CustomerParametersList.vue'),
    meta: {
      pageTitle: 'Customers Parameters',
      breadcrumb: {
        label: 'Customers Parameters',
        parent: 'customers_list'
      },
      roles: [ROLES.ADMIN, ROLES.ACCOUNT_ADMIN]
    }
  },

  {
    path: '/customers/:id/parameters/create',
    name: 'create_customers_parameters',
    component: () => import('@/views/pages/customers/CreatCustomerParameter.vue'),
    meta: {
      pageTitle: 'Create Customer Parameters',
      breadcrumb: {
        label: 'Create Customer Parameters',
        parent: 'customers_parameters_list'
      },
      roles: [ROLES.ADMIN, ROLES.ACCOUNT_ADMIN]
    }
  },

  {
    path: '/customers/:id/parameters/:parameter_id',
    name: 'edit_customers_parameters',
    component: () => import('@/views/pages/customers/EditCustomerParameter.vue'),
    meta: {
      pageTitle: 'Edit Customer Parameters',
      breadcrumb: {
        label: 'Edit Customer Parameters',
        parent: 'customers_parameters_list'
      },
      roles: [ROLES.ADMIN, ROLES.ACCOUNT_ADMIN]
    }
  },

  {
    path: '/customers/:id/documents',
    name: 'customers_documents_list',
    component: () => import('@/views/pages/customers/CustomerDocumentsList.vue'),
    meta: {
      pageTitle: 'Customers Documents',
      breadcrumb: {
        label: 'Customers Documents',
        parent: 'customers_list'
      },
      roles: [ROLES.ADMIN, ROLES.ACCOUNT_ADMIN]
    }
  },
  {
    path: '/customers/:id/documents/:document_id',
    name: 'edit_customers_documents',
    component: () => import('@/views/pages/customers/EditCustomerDocument.vue'),
    meta: {
      pageTitle: 'Edit Document Infos',
      breadcrumb: {
        label: 'Edit Document Infos',
        parent: 'customers_documents_list'
      },
      roles: [ROLES.ADMIN, ROLES.ACCOUNT_ADMIN]
    }
  },
  {
    path: '/customers/:id/assigne-provider',
    name: 'customers_assigne_provider',
    component: () => import('@/views/pages/customers/CustomerAssigneProvider.vue'),
    meta: {
      breadcrumb: {
        label: 'Assign Service Provider',
        parent: 'customers_list'
      },
      roles: [ROLES.ADMIN, ROLES.ACCOUNT_ADMIN]
    }
  },
  {
    path: '/customers/:id/destination-authorization',
    name: 'customers_destination_authorization',
    component: () => import('@/views/pages/customers/CustomerDestinationAuthorization.vue'),
    meta: {
      pageTitle: 'Destination Authorization',
      breadcrumb: {
        label: 'Destination Authorization',
        parent: 'customers_list'
      },
      roles: [ROLES.ADMIN, ROLES.ACCOUNT_ADMIN]
    }
  }
];
